import Iconify from 'src/components/Iconify';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from 'src/@/components/ui/card';
import { Label } from 'src/@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/@/components/ui/select';
import RealstateModuleConfig from './modules/RealstateModuleConfig';

const MODULE_TYPES = [
    { value: 'realstate', label: 'Imobiliária', icon: 'mdi:home-city-outline' },
];

export default function AiAgentModulosTab({ aiAgent, changeModuleAgentType, changeModuleConfig }) {
    const currentType = aiAgent?.config?.module_agent_type || '';

    return (
        <div className="flex flex-col gap-6">
            <Card className="rounded-xl border border-gray-100">
                <CardHeader>
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-violet-50">
                            <Iconify icon="eva:layers-outline" width={20} className="text-violet-600" />
                        </div>
                        <div>
                            <CardTitle>Tipo de módulo</CardTitle>
                            <CardDescription>Selecione o módulo vertical que este agente representa para habilitar configurações específicas.</CardDescription>
                        </div>
                    </div>
                </CardHeader>
                <CardContent>
                    <div className="flex flex-col gap-2 max-w-md">
                        <Label className="text-xs font-semibold uppercase tracking-wider text-gray-500">Módulo</Label>
                        <Select value={currentType} onValueChange={changeModuleAgentType}>
                            <SelectTrigger className="rounded-xl border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20">
                                <SelectValue placeholder="Selecione um tipo de módulo" />
                            </SelectTrigger>
                            <SelectContent>
                                {MODULE_TYPES.map((item) => (
                                    <SelectItem key={item.value} value={item.value}>
                                        <div className="flex items-center gap-2">
                                            <Iconify icon={item.icon} width={16} className="text-violet-600" />
                                            <span>{item.label}</span>
                                        </div>
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </div>
                </CardContent>
            </Card>

            {currentType === 'realstate' && (
                <RealstateModuleConfig aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
            )}

            {!currentType && (
                <div className="flex flex-col items-center justify-center py-16 bg-white rounded-xl border border-dashed border-gray-200">
                    <div className="w-14 h-14 rounded-2xl flex items-center justify-center bg-gray-50 mb-3">
                        <Iconify icon="eva:layers-outline" width={28} className="text-gray-300" />
                    </div>
                    <p className="text-sm font-medium text-gray-700">Nenhum módulo selecionado</p>
                    <p className="text-xs text-gray-500 mt-1">Selecione um tipo de módulo acima para configurá-lo.</p>
                </div>
            )}
        </div>
    );
}
